import React from 'react';
import { withRouter } from 'react-router-dom';
import { withApollo } from "react-apollo";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { commentFeed } from '../../graphql/queries';
import { deleteFile } from '../../graphql/mutations';
import { Tile, CardInline } from '../chunk'
import { formatFileSize } from '../../util';


class CommentAttachmentDelete extends React.Component {

	constructor(props) {
		super(props);
		
		this.state = {
			toBeDeleted: false
		};

		this.handleDelete = this.handleDelete.bind(this);
	}

	handleDelete() {
	
		if(window.confirm('delete file?')) {

			const refetchQueries = [];
			refetchQueries.push({
				query: commentFeed,
				variables: { filter: { channel: this.props.match.params.id }, cursor: '' }
			});
			
			this.props.client.mutate({
				mutation: deleteFile,
				variables: {
					id: this.props.file.id
				},
				refetchQueries
			});
		}
	}

	render() {

		//@TODO put in conf
		const path = process.env.NODE_ENV==='production' ? 'https://trashnet.de:3001' : 'http://localhost:3001';
		
		const { file } = this.props;
        let media = <FontAwesomeIcon icon="sticky-note" size="2x" />;
        if(file.type.match('image.*')) {
                media = <img src={path + '/thumb/128/' + file.filename} alt="" />;
        }
        media = <a href={path + '/upload/' + file.filename} target="_blank">{media}</a>
    
        return (
			<Tile key={file.id}>
				<CardInline media={media}>
					<button onClick={this.handleDelete} style={{float:'right'}}><FontAwesomeIcon icon="trash" /></button>
					<a href={path + '/upload/' + file.filename} target="_blank">{file.name}</a> 
					<div className="meta" style={{marginTop:'0.25rem'}}>{formatFileSize(file.size)}</div>
				</CardInline>
			</Tile>)
	}
}


export default withRouter(withApollo(CommentAttachmentDelete))


// WEBPACK FOOTER //
// ./src/components/comment/CommentAttachmentDelete.js